"use client"

import repeat from "@lib/util/repeat"
import { HttpTypes } from "@medusajs/types"
import { useFrontendPreferences } from "@lib/frontend-preferences"

import Item from "@modules/cart/components/item"
import SkeletonLineItem from "@modules/skeletons/components/skeleton-line-item"

type ItemsTemplateProps = {
  cart?: HttpTypes.StoreCart
}

const ItemsTemplate = ({ cart }: ItemsTemplateProps) => {
  const items = cart?.items
  const { t } = useFrontendPreferences()
  const count = items?.reduce((acc, i) => acc + i.quantity, 0) ?? 0

  return (
    <div>
      <div className="mb-6 flex items-baseline gap-x-3">
        <h1 className="sahil-acc-title">{t.cart.title}</h1>
        {count > 0 && <span className="sahil-acc-chip">{count}</span>}
      </div>
      <ul className="sahil-acc-card overflow-hidden divide-y divide-[var(--acc-line)]">
        {items
          ? [...items]
              .sort((a, b) =>
                (a.created_at ?? "") > (b.created_at ?? "") ? -1 : 1
              )
              .map((item) => (
                <Item
                  key={item.id}
                  item={item}
                  currencyCode={cart?.currency_code ?? ""}
                />
              ))
          : repeat(5).map((i) => (
              <li key={i}>
                <table className="w-full">
                  <tbody>
                    <SkeletonLineItem />
                  </tbody>
                </table>
              </li>
            ))}
      </ul>
    </div>
  )
}

export default ItemsTemplate
